import React, { useEffect, useState } from "react";
import imageDepard from './images/depart_outils.png';
import Passarelle1000  from './images/passarelle1000.png';
import LeFleur from './images/lefleur-1000.png';
import LeParc from './images/leparc-1000_2.png';
import LesMains from './images/lesmains-1000.png';
import MultiLearn from './images/logo-multi-learn.png';
import Menu from './Menu';

import Modal from 'react-modal';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faClose } from '@fortawesome/free-solid-svg-icons';
import './Carrosel.css';
import './ProjetTest.css';
import HomeFooter from "./components/Footer";
import CookieAlert from "./CookieAlert";

const ProjetTest = ()=>{
    const [videoPlay, setVideoPaly] = useState (false);  
  

    const [videoLeProjet, setVideoLeProjet] = useState(false);
    const [videoQuiz, setVideoLeQuiz] = useState(false);
   

  

    const handleVideoProjet = () =>{
        setVideoLeProjet(true);

        

    }
    const handleVideoQuiz = () =>{
        setVideoLeQuiz(true);

    }
    const handleClose = () =>{
        setVideoPaly(false);
        setVideoLeProjet(false);
        setVideoLeQuiz(false);
      
    
    }

return(
    <>
<Menu></Menu>
<div className="envelope-projeto">
    
    <div className="banner-projeto">
        <div className="poster_onglet">
          
            </div>
            <div className="poster_onglet_700">
          
          </div>
    </div>
     
            <div className="title-description-citation_new">
            <div className="text-citation-new">
                <p>Le fait que chacun se sente à l'aise et vive en bonne entente dans son lieu de résidence, dans son quartier, à toute heure du jour et de la nuit, quels que soient son âge, son genre et son sexe, sa langue, ses habiletés, et tout ce qui fait culture, est une condition importante du vivre ensemble et des échanges.</p>
            </div>
        </div>
            <CookieAlert></CookieAlert>

<div className="grid-container-projeto container-projet">

<div className="grid-item-projeto" id="grid1-projeto">
    <a href="/lesobjectifs">
            <div className="image-container-carte">
                <img src={LesMains}></img>

            </div>
            </a>
            <a href="/lesobjectifs">
            <div className="container-projeto-button">
                
                <button className="projeto-button" >Les objectifs du projet </button>

            </div>
            </a>
        </div>    
        <div className="grid-item-projeto" id="grid2-projeto">
            <div className="image-container-carte"  onClick={handleVideoProjet} >
                <img src={imageDepard}></img>

            </div>
       
             <div className="container-projeto-button">
                <button className="projeto-button" onClick={handleVideoProjet} >Les débuts du projet 
                </button>
               
            </div>
             <Modal 
                className="modal-content-video" 
                isOpen={videoLeProjet}
                onRequestClose = {()=> setVideoLeProjet(false)}
                overlayClassName="modal-overlay"
                ariaHideApp={false}
                
            >
                <div className='close-modal-home'>
                    <FontAwesomeIcon icon={faClose} className="icon-close" onClick={handleClose} />
                </div>
                <div className="title-video"><h2>Les débuts du projet </h2></div>
                                    
                <div>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/nGdFhr33rh0?si=obCqU53WHQwj8acy" allowFullScreen></iframe>
                </div>

            </Modal> 

        </div>
        <div className="grid-item-projeto " id="grid3-projeto">
            <div className="image-container-carte"  onClick={handleVideoQuiz}>
                <img src={Passarelle1000}></img>
            </div>
         
              <div className="container-projeto-button" >
                <button className="projeto-button" onClick={handleVideoQuiz}>La carte associative de Bonnevoie

                </button>

            </div>
            <Modal 
                className="modal-content-video" 
                isOpen={videoQuiz}
                onRequestClose = {()=> setVideoLeQuiz(false)}
                overlayClassName="modal-overlay"
                ariaHideApp={false}
                
            >
                <div className='close-modal-home'>
                    <FontAwesomeIcon icon={faClose} className="icon-close" onClick={handleClose} />
                </div>
                <div className="title-video"><h2>La carte associative de Bonnevoie</h2></div>
                                    
                <div>
                <iframe width="560" height="315" src="https://www.youtube.com/embed/mq-Nr2sCXBQ?si=OLrDHZ3OUP4egxR4" allowFullScreen></iframe></div>

            </Modal> 

        </div>
        <div className="grid-item-projeto" id="grid4-projeto">
            <a href="/voixassociations">
            <div className="image-container-carte voix-associations">
                <img  className="voix-associations-img" src={LeParc}></img>
            </div>
            </a>
            <a href="/voixassociations">

            <div className="container-projeto-button">
                <button className="projeto-button">Les voix des associations
                </button>
            </div>
</a>
        </div>
        <div className="grid-item-projeto" id="grid5-projeto">
            <a href="/dynamismebonnevoie">
            <div className="image-container-carte"  >
                <img src={LeFleur}></img>
            </div>
            </a>
            <a href="/dynamismebonnevoie">

            <div className="container-projeto-button">
                <button className="projeto-button" > Les dynamiques de Bonnevoie
                </button>
            </div>
            </a>
        </div>
        <div className="grid-item-projeto" id="grid5-projeto">
            <a href="/apropros">
            <div className="image-container-carte">
                <img src={MultiLearn}></img>
            </div>
             </a>
             <a href="/apropros">
            <div className="container-projeto-button">
            <button className="projeto-button"> À propos de nous
            </button>
            </div>
            </a>
        </div>            
    </div>
          <div className="my-footer">
          <HomeFooter></HomeFooter>
      </div>
</div>
</>
);
}
export default ProjetTest;